import { api } from './client'
import { withCustomerIds } from './params'

export function fetchZabbixSettings() {
  return api.get('/zabbix/settings').then((r) => r.data)
}

export function updateZabbixSettings(body) {
  return api.put('/zabbix/settings', body).then((r) => r.data)
}

export function triggerZabbixSync() {
  return api.post('/zabbix/sync', null, { timeout: 120000 }).then((r) => r.data)
}

export function fetchZabbixCoverage(customerIds = []) {
  return api
    .get('/zabbix/coverage', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}
